module.exports = __webpack_public_path__ + "static/media/Sagar Baraskar.e7f8a326.png";